import type { ContentBriefData } from './content-brief.interface'

type ValidatorFn = (data: unknown) => boolean

interface ContentBriefFieldValidators {
  id: ValidatorFn
  name: ValidatorFn
  version: ValidatorFn
  content: ValidatorFn
  onProceed: ValidatorFn
}

const fieldValidatorMap: ContentBriefFieldValidators = {
  id: (data) => 'id' in (data as object) && typeof (data as ContentBriefData).id === 'string',
  name: (data) => 'name' in (data as object) && typeof (data as ContentBriefData).name === 'string',
  version: (data) =>
    'version' in (data as object) && typeof (data as ContentBriefData).version === 'string',
  content: (data) =>
    'content' in (data as object) && typeof (data as ContentBriefData).content === 'string',
  onProceed: (data) =>
    !('onProceed' in (data as object)) ||
    typeof (data as ContentBriefData).onProceed === 'function',
}

export const isContentBriefData = (data: unknown): data is ContentBriefData => {
  if (typeof data !== 'object' || data === null) {
    return false
  }

  return Object.values(fieldValidatorMap).every((validator) => validator(data))
}
